import React from 'react';
import {BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from "./Home";
import TicTacToe from "./TicTacToe";
import NavBar from "./NavBar";
import Community from "./Community";

const apiKey = '';
const steamId = '76561198057901852';

function App() {
    return  (
        <div className="min-h-screen bg-gradient-to-r from-blue-950 to-blue-500">
        <Router>
            <NavBar />
            <Routes>
                <Route path="/" Component={Home} />
                <Route path="/tictactoe" Component={TicTacToe} />
                <Route path="/community" element={<Community apiKey={apiKey} steamId={steamId} />} />
            </Routes>
        </Router>
            <div>
            </div>
        </div>
    )
}

export default App;